import { render } from "./DashboardViews.vue?vue&type=template&id=8dc5ab96&scoped=true"
import script from "./DashboardViews.vue?vue&type=script&lang=js"
export * from "./DashboardViews.vue?vue&type=script&lang=js"

import "./DashboardViews.vue?vue&type=style&index=0&id=8dc5ab96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dc5ab96"]])

export default __exports__